import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=78513211&scoped=true"
import script from "./selection.vue?vue&type=script&lang=js"
export * from "./selection.vue?vue&type=script&lang=js"
import style0 from "./selection.vue?vue&type=style&index=0&id=78513211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78513211",
  null
  
)

export default component.exports